import { ChangeEvent, FC } from 'react';

import { iconInputImages } from '~src/shared/form/services';

import InputLabelWrapper from './InputLabelWrapper';
import { Input, InputImg } from './inputs.sc';

export type InputIconType = 'email' | 'user' | 'password' | 'message' | 'phone' | 'company';

interface Props {
  autoFocus?: boolean;
  error?: string;
  defaultValue?: string | string[];
  label: string;
  className?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  type: InputIconType;
  value?: string | number;
  required?: boolean;
  min?: number;
  placeholder?: string;
  labelKey: string;
}

const IconInput: FC<Props> = props => {
  const { labelKey, ...inputProps } = props;
  return (
    <InputLabelWrapper
      insideForm={false}
      valid={!props.error}
      hasValue={!!props.defaultValue || !!props.value}
      error={props.error}
      label={props.label}
      labelKey={props.labelKey}
    >
      <Input {...inputProps} $valid={!props.error} />
      <InputImg name={iconInputImages[props.type]} $valid={!props.error} />
    </InputLabelWrapper>
  );
};

export default IconInput;
